<form [formGroup]="milestoneForm">
  <div class="flex items-center justify-flex-start mt-[7px]">
    <!-- Milestone Name -->
    <div class="w-1/3">
      <mat-form-field appearance="outline" class="milestone-input">
        <mat-label>Milestone Name</mat-label>
        <input
          matInput
          type="text"
          id="name"
          formControlName="name"
          placeholder="Milestone Name"
        />
      </mat-form-field>
      
    </div>

    <!-- Start Date -->
    <div class="w-1/3">
      <mat-form-field appearance="outline">
        <mat-label>Start Date</mat-label>
        <input
          matInput
          [matDatepicker]="startDate"
          id="start_date"
          formControlName="start_date"
          [min]="projectStartDateFormatted"
          [max]="projectEndDateFormatted"
        />
        <mat-datepicker-toggle
        matIconSuffix
        [for]="startDate"
      ></mat-datepicker-toggle>
      <mat-datepicker #startDate></mat-datepicker>
      </mat-form-field>
      
    </div>

    <!-- End Date -->
    <div class="w-1/3">
      <mat-form-field appearance="outline">
        <mat-label>End Date</mat-label>
        <input
          matInput
          [matDatepicker]="endDate"
          id="end_date"
          formControlName="end_date"
          [min]="projectStartDateFormatted"
          [max]="projectEndDateFormatted"
        />
        <mat-datepicker-toggle
        matIconSuffix
        [for]="endDate"
      ></mat-datepicker-toggle>
      <mat-datepicker #endDate></mat-datepicker>
      </mat-form-field>
      
    </div>
  </div>
</form>

<div class="w-[100%] flex justify-end mb-[5px] mt-[8px] pr-[10.0625rem]">
  <div class="flex justify-start">
    <div
      class="ml-[12px] bg-[#f9dacf] px-[6px] pt-[4px] pb-[4px] rounded-[50%] flex justify-end items-center"
    >
      <img
        src="assets/icons/close.svg"
        alt="close"
        class="cursor-pointer w-[14px]"
        (click)="cancel()"
      />
    </div>
    <div class="ml-[12px] bg-[#f9dacf] p-[4px] rounded-[50%]">
      <img
        src="assets/icons/save.svg"
        alt="save"
        class="cursor-pointer w-[20px] pr-[2px]"
        (click)="save()"
      />
    </div>
  </div>
</div>
